// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2As8R","right":"styles_right__1QTRh"};